var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTrashBtn = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.18182H11M9.94737 3.72727V11.3636C9.94737 11.7976 9.78102 12.2138 9.48491 12.5207C9.1888 12.8276 8.78718 13 8.36842 13H3.63158C3.21282 13 2.8112 12.8276 2.51509 12.5207C2.21898 12.2138 2.05263 11.7976 2.05263 11.3636V3.72727M4.68421 3.18182V1.54545C4.68421 1.40079 4.73966 1.26205 4.83837 1.15976C4.93707 1.05747 5.07094 1 5.21053 1H6.78947C6.92906 1 7.06293 1.05747 7.16164 1.15976C7.26034 1.26205 7.31579 1.40079 7.31579 1.54545V3.18182M4.68421 5.90909V9.72727M7.31579 5.90909V9.72727",
    stroke: "#354ACD",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTrashBtn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/TrashBtn.c22fa8db3cfb642e65dbbdeb7629a6ee.svg";